import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.leapifyes.com';
const OG_IMAGE = 'https://res.cloudinary.com/dnjsjo6yx/image/upload/f_auto,q_auto/v1772800285/logo_de_leapifyes_circular_elr6v1.jpg';

export const SEO_DATA = {
  '/': {
    title: 'Consultoría Transformación Digital Barcelona | Leapifyes',
    description: 'Consultora de transformación digital para pymes y autónomos en Barcelona. CRM, IA y automatización. Certif. Agenda 2030. Solicita tu diagnóstico gratuito.',
    keywords: 'consultoría transformación digital Barcelona, consultora digital pymes España, automatización IA pequeña empresa, CRM para pymes Barcelona, agentes IA para negocios, digitalización autónomos España',
  },
  '/soluciones': {
    title: 'Soluciones de Transformación Digital | Leapifyes Barcelona',
    description: 'Soluciones de transformación digital para empresas: agentes IA, automatización, desarrollo web, ERP/CRM a medida y cumplimiento RGPD. Barcelona y toda España.',
    keywords: 'soluciones transformación digital, agentes IA, automatización procesos empresas, ERP CRM pymes, desarrollo web Barcelona',
  },
  '/soluciones/transformacion-digital': {
    title: 'Transformación Digital para Pymes | Leapifyes Barcelona',
    description: 'Digitalizamos tu empresa con enfoque humano. Automatización de procesos, integración de sistemas y quick wins desde la primera semana. Para pymes en Barcelona.',
    keywords: 'transformación digital pymes, digitalización empresas Barcelona, automatización procesos, consultoría digital Barcelona',
  },
  '/soluciones/agentes-ia': {
    title: 'Agentes de IA para Empresas | Atención 24/7 sin parar | Leapifyes',
    description: 'Agentes de IA que atienden clientes, cualifican leads y cierran ventas 24/7. WhatsApp, web, email. Automatización inteligente sin intervención manual.',
    keywords: 'agentes IA empresas, chatbot WhatsApp empresa, atención automatizada 24/7, agente IA ventas, automatización WhatsApp business',
  },
  '/soluciones/desarrollo-web': {
    title: 'Desarrollo Web a Medida en Barcelona | Leapifyes',
    description: 'Webs profesionales, landing pages y aplicaciones web que convierten. React, Next.js, SEO técnico y diseño UX/UI. Velocidad, rendimiento y conversión.',
    keywords: 'desarrollo web Barcelona, web a medida empresa, React desarrollo web, diseño web profesional Barcelona, landing page alta conversión',
  },
  '/soluciones/erp-crm': {
    title: 'ERP y CRM a Medida para Empresas | Leapifyes Barcelona',
    description: 'Implementación y desarrollo de ERP y CRM adaptados a tu sector. Zoho CRM, Salesforce, sistemas a medida. Pipeline de ventas, facturas y KPIs en un panel.',
    keywords: 'ERP CRM a medida, Zoho CRM implementación Barcelona, CRM pymes, sistema gestión empresarial, ERP reformas Barcelona',
  },
  '/soluciones/sistemas-medida': {
    title: 'Apps Nativas iOS/Android y Software a Medida | Leapifyes',
    description: 'Desarrollamos y publicamos apps nativas iOS y Android, plataformas SaaS y sistemas a medida. Del backend a la publicación en App Store y Google Play.',
    keywords: 'desarrollo apps nativas iOS Android, app a medida Barcelona, software a medida empresa, plataforma SaaS marketplace, publicación App Store Google Play, desarrollo Capacitor React',
  },
  '/soluciones/cumplimiento-rgpd': {
    title: 'Cumplimiento RGPD para Empresas | e-Factura | Leapifyes',
    description: 'RGPD, LOPD, e-factura y Verifactu sin dolor. Diagnóstico, documentación, implementación y auditoría continua. Cero sanciones para nuestros clientes.',
    keywords: 'cumplimiento RGPD empresa, LOPD pymes Barcelona, e-factura Verifactu, protección datos empresa, consultoría RGPD España',
  },
  '/sectores': {
    title: 'Transformación Digital por Sector | Leapifyes Barcelona',
    description: 'Soluciones de digitalización especializadas por sector: reformas, clínicas, gestorías, comercios, autónomos y pymes. Conocemos tu sector.',
    keywords: 'transformación digital sectores, digitalización por industria, soluciones sectoriales pymes, consultoría digital sector',
  },
  '/sectores/reformas': {
    title: 'Software para Empresas de Reformas y Construcción | MANDO | Leapifyes',
    description: 'ERP MANDO para reformas: presupuestos, obras, facturas e incidencias en un panel. Aumenta obras/mes y reduce horas de gestión. Barcelona y España.',
    keywords: 'software empresa reformas, ERP construcción, gestión obras digital, presupuestos reformas automáticos, MANDO ERP reformas Barcelona',
  },
  '/sectores/clinicas': {
    title: 'Digitalización para Clínicas Dentales y de Salud | Leapifyes',
    description: 'Reduce no-shows con recordatorios automáticos, gestiona citas y mejora la experiencia del paciente en tu clínica. Soluciones para clínicas en Barcelona.',
    keywords: 'software gestión clínica, digitalización clínica dental, recordatorios citas automáticos, CRM clínicas Barcelona, reducir no-shows clínica',
  },
  '/sectores/gestorias': {
    title: 'Digitalización para Gestorías y Asesorías | Leapifyes Barcelona',
    description: 'RGPD completo, digitalización de expedientes y automatización del flujo de trabajo para gestorías y asesorías. Más clientes con menos burocracia.',
    keywords: 'software gestoría digital, digitalización asesoría fiscal, RGPD gestorías, automatización gestoría, CRM gestoría Barcelona',
  },
  '/sectores/comercios': {
    title: 'Digitalización para Comercios y Retail | Leapifyes Barcelona',
    description: 'CRM, fidelización y omnicanal para comercios. Aumenta el ticket medio, retén clientes y vende más con menos esfuerzo manual.',
    keywords: 'digitalización comercio, CRM tienda retail, omnicanal comercio, fidelización clientes tienda, software comercio Barcelona',
  },
  '/sectores/autonomos': {
    title: 'Herramientas Digitales para Autónomos | Leapifyes España',
    description: 'Estructura digital para autónomos y freelancers. Gestión de clientes, automatización de tareas repetitivas y crecimiento sin caos. España.',
    keywords: 'herramientas digitales autónomos, CRM autónomo, automatización freelance, gestión clientes autónomo España, digitalización autónomos',
  },
  '/sectores/pymes': {
    title: 'Transformación Digital para PYMEs | Leapifyes España',
    description: 'Soluciones de digitalización y automatización para PYMEs en crecimiento. Escala con procesos claros, sistemas eficientes y IA a tu servicio.',
    keywords: 'transformación digital pymes, digitalización empresa mediana, automatización pymes España, consultoría crecimiento pymes',
  },
  '/productos': {
    title: 'Nuestros productos | Leapifyes — Software propio para pymes',
    description: 'Leapifyes construye y opera sus propios productos: AppMando, MANDO ERP, Agente IA y TRÉBOL Finance. Tecnología real, en producción.',
    keywords: 'productos leapifyes, software pymes, appmando, mando erp, agente ia',
  },
  '/productos/appmando': {
    title: 'AppMando | Marketplace de servicios del hogar y reformas — by Leapifyes',
    description: 'Conoce AppMando, la app de Leapifyes que conecta clientes con profesionales verificados de reformas y hogar en toda España. Disponible en App Store.',
    keywords: 'appmando, app reformas, profesionales hogar, marketplace servicios, leapifyes',
  },
  '/casos': {
    title: 'Casos de Éxito | Resultados Reales de Transformación Digital | Leapifyes',
    description: 'Empresas de Barcelona y Cataluña que han dado el salto digital con Leapifyes. Resultados medibles: +28% ticket medio, −22% absentismo, +3 obras/mes.',
    keywords: 'casos éxito transformación digital, testimonios clientes Barcelona, resultados digitalización pymes, ROI automatización empresas',
  },
  '/metodo': {
    title: 'Método Leapifyes | Cómo Digitalizamos tu Empresa en 90 Días',
    description: 'Metodología probada: diagnóstico, plan 90 días, implantación guiada, formación y KPIs. Quick wins desde la primera semana. Sin tecnicismos.',
    keywords: 'metodología transformación digital, cómo digitalizar empresa, proceso digitalización 90 días, consultoría digital metodo Barcelona',
  },
  '/empresa': {
    title: 'Sobre Leapifyes | Tu Socio Digital en Barcelona',
    description: 'Somos tu socio digital en Barcelona. Expertos en transformación digital para PYMEs. Digital con corazón: lo humano siempre primero.',
    keywords: 'Leapifyes Barcelona, empresa transformación digital, quiénes somos, equipo digital Barcelona, Ricardo Serrano Leapifyes',
  },
  '/recursos': {
    title: 'Blog y Guías de Transformación Digital | Leapifyes',
    description: 'Artículos, guías y recursos prácticos sobre transformación digital, automatización e IA para empresas en España. Sin tecnicismos, con ejemplos reales.',
    keywords: 'blog transformación digital, guías digitalización empresas, recursos automatización IA, artículos pymes digital España',
  },
  '/contacto': {
    title: 'Contactar con Leapifyes | Diagnóstico Gratuito en 24h',
    description: 'Agenda tu diagnóstico gratuito. Analizamos tu negocio y te proponemos soluciones a medida. Respuesta garantizada en 24h. Barcelona y España.',
    keywords: 'contacto Leapifyes, agendar diagnóstico digital, consulta transformación digital gratuita, demo agentes IA Barcelona',
  },
  '/barcelona': {
    title: 'Transformación Digital en Barcelona | Expertos Locales | Leapifyes',
    description: 'Expertos en transformación digital para empresas de Barcelona. Conocemos el tejido empresarial local. Eixample, Gràcia, Hospitalet, Badalona y toda el área metropolitana.',
    keywords: 'transformación digital Barcelona, consultora digital Barcelona, agentes IA Barcelona, digitalización pymes Barcelona, empresa digital Barcelona',
  },
  '/cataluna': {
    title: 'Transformación Digital en Cataluña | Leapifyes',
    description: 'Acompañamos a empresas de toda Cataluña en su transformación digital. Presencia en Barcelona, Girona, Tarragona y Lleida. Conocemos el mercado catalán.',
    keywords: 'transformación digital Cataluña, digitalización empresas Catalunya, agentes IA Girona, consultoría digital Tarragona Lleida',
  },
  '/sabadell': {
    title: 'Transformación Digital en Sabadell | Leapifyes — Vallès Occidental',
    description: 'Expertos en digitalización para empresas de Sabadell y el Vallès Occidental. Automatización, agentes IA y ERP a medida. Diagnóstico gratuito.',
    keywords: 'transformación digital Sabadell, digitalización empresas Sabadell, agentes IA Sabadell, consultora digital Vallès Occidental, automatización pymes Sabadell',
  },
  '/terrassa': {
    title: 'Transformación Digital en Terrassa | Leapifyes — Vallès Occidental',
    description: 'Digitalización para empresas de Terrassa. IA, automatización y ERP a medida para industria, comercio y servicios. Diagnóstico gratuito sin compromiso.',
    keywords: 'transformación digital Terrassa, digitalización empresas Terrassa, agentes IA Terrassa, consultora digital Vallès, automatización pymes Terrassa',
  },
  '/badalona': {
    title: 'Transformación Digital en Badalona | Leapifyes — Barcelonès',
    description: 'Expertos en digitalización para empresas de Badalona. Reducimos no-shows en clínicas un 22%. IA, automatización y ERP. Diagnóstico gratuito.',
    keywords: 'transformación digital Badalona, digitalización pymes Badalona, agentes IA Badalona, clínicas Badalona digitalización, consultora digital Barcelonès Nord',
  },
  '/hospitalet': {
    title: "Transformación Digital en L'Hospitalet | Leapifyes — Barcelonès",
    description: "Digitalizamos empresas de L'Hospitalet de Llobregat. ERP MANDO para reformas, agentes IA y automatización. Casos de éxito reales. Diagnóstico gratuito.",
    keywords: "transformación digital L'Hospitalet, digitalización empresas Hospitalet, agentes IA Hospitalet, ERP reformas Hospitalet, consultora digital Barcelonès",
  },
  '/girona': {
    title: 'Transformación Digital en Girona | Leapifyes — Costa Brava',
    description: 'Digitalizamos empresas de Girona, Costa Brava y el Empordà. IA, automatización y ERP para turismo, servicios e industria. Diagnóstico gratuito.',
    keywords: 'transformación digital Girona, digitalización empresas Girona, agentes IA Girona, consultora digital Costa Brava, automatización pymes Empordà',
  },
  '/tarragona': {
    title: 'Transformación Digital en Tarragona | Leapifyes — Camp de Tarragona',
    description: 'Digitalización para empresas de Tarragona, Reus y la Costa Daurada. IA, automatización y cumplimiento RGPD. Diagnóstico gratuito sin compromiso.',
    keywords: 'transformación digital Tarragona, digitalización pymes Tarragona, agentes IA Tarragona, consultora digital Reus, automatización empresas Costa Daurada',
  },
  '/lleida': {
    title: 'Transformación Digital en Lleida | Leapifyes — Ponent',
    description: 'Digitalizamos empresas de Lleida y las comarcas de Ponent. Agroalimentario, industria y servicios. IA, automatización y ERP. Diagnóstico gratuito.',
    keywords: 'transformación digital Lleida, digitalización empresas Lleida, agentes IA Lleida, consultora digital Ponent, automatización pymes Lleida agroalimentario',
  },
  '/legal/privacidad': {
    title: 'Política de Privacidad | Leapifyes',
    description: 'Política de privacidad y protección de datos de Leapifyes (DigitalLeap Solutions S.L.U.). Cumplimiento RGPD.',
    keywords: 'política privacidad Leapifyes, RGPD, protección datos',
  },
  '/legal/cookies': {
    title: 'Política de Cookies | Leapifyes',
    description: 'Información sobre el uso de cookies en el sitio web de Leapifyes.',
    keywords: 'política cookies, gestión cookies, consentimiento cookies',
  },
  '/legal/aviso-legal': {
    title: 'Aviso Legal | Leapifyes',
    description: 'Aviso legal y condiciones de uso del sitio web de Leapifyes (DigitalLeap Solutions S.L.U.).',
    keywords: 'aviso legal, términos uso, condiciones legales Leapifyes',
  },
};

const SEO = ({
  title,
  description,
  keywords,
  path = '/',
  image,
  type = 'website',
  noindex = false,
  schema,
  children,
}) => {
  const seoData = SEO_DATA[path] || SEO_DATA['/'];
  const finalTitle = title || seoData.title;
  const finalDescription = description || seoData.description;
  const finalKeywords = keywords || seoData.keywords;
  const finalImage = image || OG_IMAGE;
  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      {noindex
        ? <meta name="robots" content="noindex,nofollow" />
        : <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
      }

      <link rel="canonical" href={canonicalUrl} />

      <html lang="es" />
      <meta property="og:locale" content="es_ES" />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="800" />
      <meta property="og:image:height" content="800" />
      <meta property="og:image:alt" content="Leapifyes — Transformación Digital en Barcelona" />
      <meta property="og:site_name" content="Leapifyes" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@leapifyes" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
      <meta name="twitter:image:alt" content="Leapifyes — Transformación Digital en Barcelona" />

      <meta name="author" content="Leapifyes — DigitalLeap Solutions S.L.U." />
      <meta name="geo.region" content="ES-CT" />
      <meta name="geo.placename" content="Barcelona" />

      {schema && (Array.isArray(schema) ? schema : [schema]).map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}

      {children}
    </Helmet>
  );
};

export default SEO;
